import * as React from "../_snowpack/pkg/react.js";
export const defaultDuration = {months: 1};
export const defaultStartDate = new Date();
export const DurationCtx = React.createContext({
  duration: defaultDuration,
  setDuration: () => {
  }
});
export function useDuration() {
  const [duration, localSetDuration] = React.useState(defaultDuration);
  const setDuration = React.useCallback((value) => {
    localSetDuration(value);
  }, []);
  return [duration, setDuration];
}
